const project = {
	name: 'React-GitHub_Users',
	nav: {
		dashboard: '/React-GitHub_Users',
		login: '/React-GitHub_Users/login',
		error: '*'
	}
};

export { project };
